import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=2e5757b0&"
import script from "./ResetForm.vue?vue&type=script&lang=js&"
export * from "./ResetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5757b0')) {
      api.createRecord('2e5757b0', component.options)
    } else {
      api.reload('2e5757b0', component.options)
    }
    module.hot.accept("./ResetForm.vue?vue&type=template&id=2e5757b0&", function () {
      api.rerender('2e5757b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/ResetForm.vue"
export default component.exports